/**
 * Defines the default on loading timeout.
 * @type {number}
 */
export const DEFAULT_TIMEOUT = 10000;
//# sourceMappingURL=MicroFrontends.constants.js.map